export const END_REASON_MARKER = '[[结束原因]]'

export const parseAliPracticeEndContent = (content = '') => {
  const rawContent = String(content || '')
  const markerIndex = rawContent.indexOf(END_REASON_MARKER)
  const protocolStartIndex = markerIndex !== -1 ? markerIndex : rawContent.indexOf('[[')
  const displayContent =
    protocolStartIndex === -1 ? rawContent : rawContent.slice(0, protocolStartIndex)

  return {
    displayContent: displayContent.replace(/\s+$/, ''),
    endReason:
      markerIndex === -1 ? '' : rawContent.slice(markerIndex + END_REASON_MARKER.length).trim(),
    hasEndMarker: markerIndex !== -1
  }
}
